import { z } from 'zod';
/**
 * Webhook Webhook v3 Configuration Validator
 * Validates webhook configuration including URL, secret, and payload
 */
export const Webhook_Webhook_3_ConfigValidator = z.object({
    webhookConnectionId: z.string().nullable().optional(),
    url: z.string().optional(),
    requestMethod: z.enum(['GET', 'POST', 'PUT', 'DELETE', 'PATCH']).default('POST'),
    headers: z.record(z.string(), z.string()).optional(),
    payload: z.record(z.string(), z.any()).optional(),
    expectedOutput: z
        .string()
        .optional()
        .refine((val) => {
        if (!val || val === '')
            return true; // Allow undefined, null, or empty string
        try {
            JSON.parse(val); // Try to parse as JSON
            return true;
        }
        catch {
            return false; // Invalid JSON
        }
    }, {
        error: 'Must be empty string or valid JSON'
    })
});
//# sourceMappingURL=webhook-webhook-3.js.map